import React, { lazy } from 'react';
import Tool from '../../shared/components/Tool';
import {
	MUTATION_DELETE_MD_CASE,
	MUTATION_UPDATE_MD_CASE,
} from '../../shared/gql/mutations';
import {
	QUERY_GET_ALL_MD_CASES,
	QUERY_GET_MD_CASE,
} from '../../shared/gql/queries';
import CaseProvider from '../../shared/providers/CaseProvider';

const MietendeckelCase = lazy(() => import('./MietendeckelCase'));
const Mietendeckel = () => (
	<CaseProvider caseMutation={MUTATION_UPDATE_MD_CASE}>
		<Tool
			caseQuery={QUERY_GET_MD_CASE}
			allCasesQuery={QUERY_GET_ALL_MD_CASES}
			deleteMutation={MUTATION_DELETE_MD_CASE}
			partitionKey='B'
		>
			<MietendeckelCase />
		</Tool>
	</CaseProvider>
);

export default Mietendeckel;
